import React, { ReactNode } from 'react';
import { Drawer, DrawerTrigger, DrawerContent, DrawerHeader, DrawerCloseButton } from '@fiverr-private/overlay';
import { Text } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { Stack } from '@fiverr-private/layout_components';

export interface BriefDrawerProps {
  trigger?: ReactNode;
  children: ReactNode;
  reportDropdown?: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  onAnimationEnd?: () => void;
}

export const BriefDrawer = ({
  trigger,
  children,
  isOpen,
  onClose,
  reportDropdown,
  onAnimationEnd,
}: BriefDrawerProps) => (
  <Drawer isOpen={isOpen} onClose={onClose}>
    {trigger && <DrawerTrigger>{trigger}</DrawerTrigger>}
    <DrawerContent size="xl" onAnimationEnd={onAnimationEnd}>
      <DrawerHeader>
        <Stack direction="row" alignItems="center" justifyContent="spaceBetween">
          <Text size="b_lg" fontWeight="bold">
            <I18n k="brief_preview_drawer.title" />
          </Text>
          <Stack direction="row" alignItems="center">
            {reportDropdown}
            <DrawerCloseButton onClick={onClose} />
          </Stack>
        </Stack>
      </DrawerHeader>
      {children}
    </DrawerContent>
  </Drawer>
);
